import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Grid } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import enGB from 'date-fns/locale/en-GB'
import enDE from 'date-fns/locale/de'
import Upload from '../../components/fs-file-upload/fs-upload'
import { configurationAPI } from '../../shared/api/ConfigurationAPI'

const FsImportView = () => {
  const { t, i18n } = useTranslation()
  const [readyToTrigger, setReadyToTrigger] = useState<boolean>(false)
  const [running, setRunning] = useState<boolean>(false)
  const [triggerSuccess, setTriggerSuccess] = useState<boolean | null>(null)
  const [startValue, setStartValue] = useState<Date | null>(null)

  const loadConfiguration = () => {
    configurationAPI.getConfiguration().then((response) => {
      const { steps } = response
      if (steps.every((step) => step.finished === true)) {
        setReadyToTrigger(true)
      }
    }).catch((error) => {
        // Error is caught, but do nothing
      })
  }

  const triggerAnalysis = () => {
    if (!readyToTrigger || !startValue) {
      return
    }

    setRunning(true)
    configurationAPI
      .triggerAnalysis(startValue)
      .then(() => {
        setTriggerSuccess(true)
        setRunning(false)
      })
      .catch(() => {
        setTriggerSuccess(false)
        setRunning(false)
      })
  }

  useEffect(() => {
    loadConfiguration()
  }, [])

  const defaultLocale = i18n.language === 'en' ? enGB : enDE

  return (
    <div>
      <h1>{t('import.data')}</h1>
      <Grid container mb={4}>
        <Grid size={{xs: 12, md: 8, lg: 6, xl: 4}}>
          <Upload />
        </Grid>
      </Grid>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={defaultLocale}>
        <DatePicker
          disableFuture
          label={t('start.date')}
          views={['year', 'month', 'day']}
          value={startValue}
          maxDate={new Date()}
          onChange={(newValue: any) => {
            if (newValue) {
              setStartValue(newValue)
            }
          }}
          slotProps={{
            field: {
              readOnly: true,
            },
          }}
        />
      </LocalizationProvider>
      <Button
        disabled={!readyToTrigger || running || !startValue}
        variant="contained"
        sx={{ ml: 4 }}
        onClick={triggerAnalysis}
      >
        {running ? 'Analysing...' : 'Analyse'}
      </Button>
      {triggerSuccess === true ? <h4>Analysis trigger successful</h4> : null}
      {triggerSuccess === false ? <h4>Analysis trigger failed</h4> : null}
    </div>
  )
}

export default FsImportView
